import { Reducer } from "redux";

import { AuthAction, AuthActionTypes, AuthState } from "./types";

const initialState: AuthState = {
  hasToken: false,
  isLoading: false,
};

const reducer: Reducer<AuthState, AuthAction> = (state = initialState, action) => {
  switch (action.type) {
    case AuthActionTypes.FETCH_REQUEST: {
      return { ...state, isLoading: true };
    }

    case AuthActionTypes.FETCH_ERROR: {
      return { ...state, isLoading: false };
    }

    case AuthActionTypes.FETCH_SUCCESS: {
      return { ...state, isLoading: false, hasToken: true };
    }

    case AuthActionTypes.LOGOUT: {
      return {
        ...state,
        hasToken: false,
      };
    }

    default:
      return state;
  }
};

export default reducer;
